<template>
  <v-dialog
    v-model="isOpenModaleInfosManquantes"
    persistent
    width="500"
  >
    <v-card>
      <AgrButton
        class="float-right pt-2"
        icon
        @click="close"
      >
        <v-icon>mdi-close</v-icon>
      </AgrButton>
      <v-card-text class="secondary--text pa-5 titre-h4">
        {{ titre }}
      </v-card-text>

      <v-card-text class="subtitle-1">
        <slot />
      </v-card-text>

      <v-card-actions class="pa-4">
        <AgrButton
          color="primary"
          block
          large
          @click="confirm"
        >
          {{ confirmText }}
        </AgrButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'InfoModal',
  components: { AgrButton },
  props: {
    titre: {
      type: String,
      default: 'Information'
    },
    confirmText: {
      type: String,
      default: 'J\'ai compris'
    },
    isOpenModaleInfosManquantes: {
      type: Boolean,
      default:false
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}
</script>
